//Begin Google Analytics Enhanced Ecommerce JS

function onCollectionPageLoad(collectionTitle, collectionId, collectionHandle, collectionSortBy, collectionDefaultSortBy) {
    convertData.collection.name = collectionTitle;
	convertData.collection.id = collectionId;
	convertData.collection.handle = collectionHandle;
	if (collectionSortBy != "") {
		convertData.collection.sortBy = collectionSortBy;
	} else {
		convertData.collection.sortBy = collectionDefaultSortBy;
	}
	dataLayer.push({
		"event" : "impressionListViewed"
	});
}

function onSearchResultsLoad(searchQueryTitle) {
  dataLayer.push({
    "event" : "impressionListViewed"
  });
}

function addListClickListener() {
	document.addEventListener("click", function(event) {
    	if (event.target.closest('.product_item')) {
      		var clickedProductId = event.target.closest('.product_item').dataset.productItemId;
			for (var i = 0; i < convertData.product.productImpressionInfo.length; i++) {
        		if (clickedProductId == convertData.product.productImpressionInfo[i].id) {
          			listActions(convertData.product.productImpressionInfo[i], "click");
                    break;
        		}
      		}
    	}
    	if (event.target.closest('#AddToCartNew')) {
      		var clickedProductId = event.target.closest('.product_item').dataset.productItemId;
      		for (var i = 0; i < convertData.product.productImpressionInfo.length; i++) {
              if (clickedProductId == convertData.product.productImpressionInfo[i].id) {
                  listActions(convertData.product.productImpressionInfo[i], "add");
              }
      		}
    	}
	}, false); 
}

function listActions(clickedProduct, productAction) {
	if (productAction == "click") {
      convertData.product.productClickInfo.push(clickedProduct);
      convertData.lastAction.productClicked = convertData.product.productClickInfo[convertData.product.productClickInfo.length - 1];
      dataLayer.push({
          "event" : "listClick"
      });
    }
	//on ATC from list, we want to fire a click and an add
	if (productAction == "add") {     
		convertData.lastAction.addedToCart = clickedProduct;
		convertData.lastAction.addedToCart.quantity = 1;
		dataLayer.push({
			"event" : "listATC"
		});
  	}
}

function onProductPageLoad(productTitle, productId, productSku, productHandle, productType, productBrand, productPrice, productVariant) {
    //Prevents sending the default value to GA
  	if(productVariant == "Default Title") {
    	productVariant = "";
  	}
	convertData.product.productViewInfo.push({
		name: productTitle,
		id: productId,
		sku: productSku,
		handle: productHandle,
		type: productType,
		brand: productBrand,
		price: productPrice,
		variant: productVariant
    });
    convertData.lastAction.productViewed = convertData.product.productViewInfo[convertData.product.productViewInfo.length - 1];
	dataLayer.push({
		"event" : "productDetailView"
	});
}

function addProductDetailClickListener() {
	document.addEventListener("click", function(event) {
		//checking for an add to cart
		if (event.target.closest('.add-to-cart-btn')) {
			productDetailActions(convertData.lastAction.productViewed);
		}
	}, false); 
}

function productDetailActions(addedProduct) {
	//product added to cart is the same as the product viewed on PDP, with a few unique object properties
	convertData.lastAction.addedToCart = addedProduct;
	//include quantity based on what is in the quantity box on the page
    convertData.lastAction.addedToCart.quantity = parseInt(document.querySelector("#Quantity").value, 10);
	dataLayer.push({
		"event" : "pdpATC"
	});
}
//End Google Analytics Enhanced Ecommerce JS


// Begin TULA product repositioning code

var CONVERT_RELEVANCE_RANK_URL = "https://convert-relevance-avatria-shared01-use2.avatria.cloud/infer/rank";
var CAMPAIGN_ID = "10ddf10d-2176-4775-8032-51982c784c7e";

function getQuerystring(url, key) {
	if (!url.startsWith("http")) {
		url = window.location.protocol + url;
	}
	var params = new URL(url).searchParams;
	return params.get(key);
}

function createRelevanceRankRequest(campaignId, itemIds, queryId) {
    var r = {
        "campaignId": campaignId,
        "items": [],
        "query": {
            "id": queryId
        }
    };
    var index;
    for (index in itemIds) {
        r.items.push({
            "id": itemIds[index]
        });
    }
    return r;
}

function doRankRequest(body) {
    var rankResponse = null;
    var rankRequest = new XMLHttpRequest();
    rankRequest.open("POST", CONVERT_RELEVANCE_RANK_URL, false);
    rankRequest.setRequestHeader("Content-Type", "application/json");
    rankRequest.addEventListener("readystatechange", function(response) {
        var rankResponseStatus = response.target.status;
        if (this.readyState === 4 && rankResponseStatus === 200) {
            console.log('rankRequest callback invoked, responseText=', response.target.responseText);
            rankResponse = JSON.parse(response.target.responseText);
        }
    });
    rankRequest.send(JSON.stringify(body));
    return rankResponse; // will be null if error
}

function getQueryId() {
	if (convertData) {
		return 'Category - ' + convertData.collection.name;
	}
	return null;
}

function isPromoElement(e) {
	return e.className.indexOf("promo") >  -1;
}

function isConvertSortEnabled() {
	var acQueryStringVal = getQuerystring(window.location.href, "_ac");
	return acQueryStringVal === "1" && window.location.href.indexOf('#') < 0;
}

function doReposition() {

	var itemIds = [];
	var itemsById = {};
	var plGridWrapper = document.getElementsByClassName("product_list grid")[0];
	var originalItems = [];
	for (var i = 0; i < plGridWrapper.children.length; i++) {
		originalItems.push(plGridWrapper.children[i]);
	}

	for (var i = 0; i < originalItems.length; i++) {
		if (!isPromoElement(originalItems[i])) {
			var productId = originalItems[i].children[0].getAttribute('data-product-item-id').toString();
			itemIds.push(productId);
			itemsById[productId] = originalItems[i];
		}
	}

	var body = createRelevanceRankRequest(CAMPAIGN_ID, itemIds, getQueryId());
	var rankResponse;
	try {
		rankResponse = doRankRequest(body);
	} catch (e) {
		console.log(e);
	}
	// null rankResponse indicates error and we should behave as if we are disabled
	console.log('rank request sent [rankResponse]', rankResponse);

	if (rankResponse) {
		var sortedItems = [];
		var idToPosition = {};
		for (var i = 0; i < rankResponse.items.length; i++) {
			var item = rankResponse.items[i];
			sortedItems.push(itemsById[item.id]);
			idToPosition[item.id] = i + 1;
		}

		// update convertData product positions
		if (convertData) {
			var productImpressionInfo = convertData.product.productImpressionInfo;
			for (var i = 0; i < productImpressionInfo.length; i++) {
				productImpressionInfo[i].position = idToPosition[productImpressionInfo[i].id];
			}
		}

		// update position of products in pl grid
		var newGrid = document.createDocumentFragment();
		for (var i = 0; i < originalItems.length; i++) {
			if (isPromoElement(originalItems[i])) {
				newGrid.appendChild(originalItems[i]);
			} else {
				newGrid.appendChild(sortedItems.shift());
			}
		}

		plGridWrapper.innerHTML = null;
		plGridWrapper.appendChild(newGrid);

		console.log("repositioning items done");
	}
}


document.addEventListener('DOMContentLoaded', function(event) {
	if (isConvertSortEnabled()) {
		doReposition();
	}
});

// End TULA product repositioning code


/* Begin Experiment Entry Code */

var EXP_TRACKING_ID = "UA-47011405-1";
var EXP_ID = "TieiKLyyTDKf0hQhwM_lCw";

// EXP_REFS should contain the actual 'href' values in the anchor tag,
// not the fully qualified URL.
var EXP_HREFS = [
	"/collections/embrace-your-skin-kits",
	"/collections/aging",
	"/collections/almost-gone",
	"/collections/auto-delivery",
	"/collections/award-winners",
	"/collections/award-winning-products",
	"/collections/back-in-stock",
	"/collections/best-sellers",
	"/collections/acne-prone-skin",
	"/collections/blue-light-protection",
	"/collections/facial-cleanser",
	"/collections/courtneys-skincare-favorites",
	"/collections/cyber-monday-must-haves",
	"/collections/digestive-health",
	"/collections/dry-skin",
	"/collections/dull-skin",
	"/collections/face-exfoliants",
	"/collections/eye-balm-collection",
	"/collections/eye-care",
	"/collections/face-mist",
	"/collections/facebook-product-feed",
	"/collections/flow-canada-product-catalog",
	"/collections/gifts-35-65",
	"/collections/gifts-over-65",
	"/collections/glow-up-routine",
	"/collections/healthy-skin-routines",
	"/collections/holiday-gift-guide",
	"/collections/no-makeup-makeup",
	"/collections/facial-masks",
	"/collections/skincare-moisturizers",
	"/collections/mothers-day-gift-guide",
	"/collections/new-years-eve-glow",
	"/collections/no-makeup-skincare",
	"/collections/non-sale-items",
	"/collections/oily-skin",
	"/collections/routine-page",
	"/collections/routine-page-products",
	"/collections/sensitive-skin-skincare",
	"/collections/serums",
	"/collections/shawn-johnson-exclusives",
	"/collections/spring-skincare-favorites",
	"/collections/staying-warm",
	"/collections/sunscreen",
	"/collections/beauty-supplements",
	"/collections/treatments",
	"/collections/facial-toners",
	"/collections/travel-size",
	"/collections/travel-skincare-kits",
	"/collections/tula-exclusive",
	"/collections/tula-non-auto-delivery-items",
	"/collections/all",
	"/collections/dark-spots-skin-care",
	"/collections/uneven-skin",
	"/collections/valentines-day-self-care",
	"/collections/kits-gifts",
	"/collections/vegan-skincare",
	"/collections/winter-favorites"
];
var EXP_CONVERT_QUERY_STRING = "_ac=1";
var EXP_CONVERT_VARIANT = 1;

var hashCode = function(value) {
	var hash = 0;
	if (value && value.length > 0) {
		for (var i = 0; i < value.length; i++) {
			chr = value.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0;
		}
	}
	return hash;
};

var createExperimentInfo = function() {
	var info = {
		trackerName: null,
		trackingId: null,
		clientId: null,
		variant: null,
		experimentVariantId: null,
		entered: false
	};
	return info;
};

var getSessionStorageKey = function() {
	return "_acexp:" + EXP_ID;
};

var getExperimentInfo = function() {
	var infoString = sessionStorage.getItem(getSessionStorageKey());
	if (infoString) {
		return JSON.parse(infoString);
	} else {
		var info = createExperimentInfo();
		updateExperimentInfo(info);
		return info;
	}
};

var updateExperimentInfo = function(info) {
	var key = getSessionStorageKey();
	if (info) {
		sessionStorage.setItem(key, JSON.stringify(info));
	} else {
		sessionStorage.removeItem(key);
	}
};

var toVariant = function(clientId) {
	return Math.abs(hashCode(clientId) % 2);
};

var toExperimentVariantId = function(clientId) {
	return EXP_ID + "." + toVariant(clientId);
};

var initExperimentInfo = function(trackerName, trackingId, clientId) {
	var info = getExperimentInfo();
	info.trackerName = trackerName;
	info.trackingId = trackingId;
	info.clientId = clientId;
	info.variant = toVariant(clientId);
	info.experimentVariantId = toExperimentVariantId(clientId);
	updateExperimentInfo(info);
};

var isExperimentInfoInitialized = function() {
	var info = getExperimentInfo();
	return info && info.trackerName;
};

var hasEnteredExperiment = function() {
	var info = getExperimentInfo();
	return info.entered;
};

var tryEnterExperiment = function() {
	// sets experiment flag on user in GA, update session stogage flag to indicate we are entered
	var info = getExperimentInfo();

	if (info.trackerName) {
		// Fire GA events to ensure user is associated to experiment.
		// We use the 'beacon' transport to ensure event is sent even if the page starts to unload before the GA event is sent.
		ga(info.trackerName + ".set", "exp", info.experimentVariantId);
		ga(info.trackerName + ".send", "event", "Convert Experiment", "Entry", info.experimentVariantId, {
			'transport': 'beacon',
			'hitCallback': function() {
				// once we have confirmation the event has been sent, update flag indicating user has enetered the experiment.
				// no need to re-send this GA event next time they click on an experiment link.
				info.entered = true;
				updateExperimentInfo(info);
			}
		});
		return true;
	} else {
		console.log("ga tracker unavailable. cannot enter user into experiment.");
	}

	return false;
};

var awaitGA = function() {
  try {
      if (ga && typeof ga === 'function') {
          if (!isExperimentInfoInitialized()) {
              ga(initializeExperimentInfoWhenReady);
          }
      }
	} catch (err) {
		setTimeout(awaitGA, 500);
	}
    
};

var initializeExperimentInfoWhenReady = function() {
	try {
		var trackers = ga.getAll();
		for (var i = 0; i < trackers.length; i++) {
			var trackerName = trackers[i].get('name');
			var trackingId = trackers[i].get('trackingId');
			var clientId = trackers[i].get('clientId');
			// use first tracker if tracking ID is not set
			if (!EXP_TRACKING_ID || trackingId === EXP_TRACKING_ID) {
				initExperimentInfo(trackerName, trackingId, clientId);
				break;
			}
		}
	} catch (e) {
		console.log(e);
	}
};

var rewriteAnchorForConvert = function(event, anchor) {
	var attrs = ["href", "data-href"];
	for (var i = 0; i < attrs.length; i++) {
		var attr = attrs[i];
		if (anchor.hasAttribute(attr)) {
			var href = anchor.getAttribute(attr);
			var queryParamPrefix = "?";
			if (href.indexOf("?") > -1) {
				queryParamPrefix = "&";
			}
			href += queryParamPrefix + EXP_CONVERT_QUERY_STRING;
			anchor.setAttribute(attr, href);
		}
	}
};

var isExperimentAnchor = function(anchor) {
	// Note: can be updated to anchor.href if we want to match using fully qualified URLs
	if (anchor.hasAttribute("href") || anchor.hasAttribute("data-href")) {
		for (var i = 0; i < EXP_HREFS.length; i++) {
			var h = EXP_HREFS[i];
			if (anchor.getAttribute("href") === h || anchor.getAttribute("data-href") === h) {
				return true;
			}
		}
	}
	return false;
};

var experimentAnchorClicked = function(event, anchor) {
	var entered = hasEnteredExperiment() || tryEnterExperiment();
	if (entered) {
		var info = getExperimentInfo();
		if (info.variant == EXP_CONVERT_VARIANT) {
			rewriteAnchorForConvert(event, anchor);
		}
	}
};

var anchorClickEventListener = function(event) {
	var target = event.target || event.srcElement;
	if (target.tagName === 'A' && isExperimentAnchor(target)) {
		experimentAnchorClicked(event, target);
	}
};

var registerListeners = function() {
	if (document.addEventListener) {
		document.addEventListener('click', anchorClickEventListener, true);
	}
};

var install = function() {
	awaitGA();
	registerListeners();
};

install();

/* End Experiment Entry Code */